import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Bell, Trash2 } from "lucide-react";

export function SavedAlertsPanel() {
  const [alerts, setAlerts] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/alerts");
      setAlerts(data);
    } catch (err) {
      console.error("Alerts load failed:", err);
    }
  };
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    try {
      await api.delete(`/alerts/${id}`);
      toast.success("Alert removed");
      load();
    } catch (err) {
      console.error("Alert delete failed:", err);
      toast.error("Failed");
    }
  };

  if (alerts.length === 0) {
    return (
      <div data-testid="alerts-empty" className="border hairline p-6 text-center">
        <Bell size={20} className="mx-auto text-neutral-500" />
        <p className="text-neutral-400 text-sm mt-2">No saved alerts yet.</p>
        <p className="text-neutral-500 text-xs mt-1">Save a filter on the Browse page and we'll email you when a matching kitchen goes live.</p>
      </div>
    );
  }

  return (
    <div data-testid="alerts-list" className="border hairline divide-y" style={{ borderColor: "rgba(255,255,255,0.08)" }}>
      {alerts.map((a) => (
        <div key={a.id} data-testid={`alert-${a.id}`} className="p-4 flex items-center justify-between gap-4">
          <div className="flex-1 min-w-0">
            <div className="flex flex-wrap gap-2 items-center">
              {a.q && <span className="tick-label">"{a.q}"</span>}
              {a.city && <span className="tick-label">· {a.city}</span>}
              {a.max_rate != null && <span className="tick-label">· ≤ ${a.max_rate}/hr</span>}
            </div>
            {a.amenities?.length > 0 && (
              <div className="mt-1.5 flex flex-wrap gap-1.5">
                {a.amenities.map((am, i) => (
                  <span key={i} className="text-xs border hairline px-2 py-0.5">{am}</span>
                ))}
              </div>
            )}
          </div>
          <button data-testid={`alert-delete-${a.id}`} onClick={() => del(a.id)} className="text-neutral-500 hover:text-[#FF3B30]">
            <Trash2 size={16} />
          </button>
        </div>
      ))}
    </div>
  );
}
